import { useEffect, useState } from 'react'

/**
 * Activa quando o elemento entra no viewport (ou está prestes a entrar).
 * Útil para adiar fetch de dados abaixo da dobra sem alterar o layout.
 */
export function useLazyWhenVisible(ref, rootMargin = '240px') {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const el = ref.current
    if (!el || visible) return undefined

    if (typeof IntersectionObserver === 'undefined') {
      setVisible(true)
      return undefined
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true)
          observer.disconnect()
        }
      },
      { rootMargin }
    )

    observer.observe(el)
    return () => observer.disconnect()
  }, [ref, rootMargin, visible])

  return visible
}
